import * as React from "react";
import {Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button} from 'react-bootstrap';

interface IssueBubbleProps {
    isEnabled: boolean,
    contractId: string,
    modalMessage: string,
    modalTitle: string,
    classString: string,
    onConfirm: Function
}

interface ModalState {
    showModal: boolean
}

export default class ConfirmModal extends React.Component<IssueBubbleProps, ModalState> {
    constructor(props: IssueBubbleProps) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    close(event: React.MouseEvent<Button>) {
        event.stopPropagation();
        this.setState({showModal: false});
    }

    open(event: React.MouseEvent) {
        event.stopPropagation();
        if(this.props.isEnabled){this.setState({showModal: true});}
    }

    confirm(event: React.MouseEvent<Button>) {
        this.props.onConfirm(this.props.contractId);
        this.close(event);
    }

    render(){
        let {modalMessage, modalTitle, classString} = this.props;

        let footer = <ModalFooter>
            <Button bsStyle="default" onClick={(e) => this.close(e)}>Avbryt</Button>
            <Button bsStyle="default" onClick={(e) => this.confirm(e)}>Bekreft</Button>
        </ModalFooter>;

        return(
            <span>
                    <button onClick={(e) => this.open(e)} className={classString} title={modalTitle} >
                        <span className={"sr-only"}>{modalTitle}</span>
                    </button>

                {this.state.showModal &&
                    <Modal show={true} onHide={(e: React.MouseEvent<Button>) => this.close(e)} aria-labelledby={"modalTitle"} aria-describedby={"modalBody"}>
                        <ModalHeader>
                            <ModalTitle id={"modalTitle"}>{modalTitle}</ModalTitle>
                        </ModalHeader>
                        <ModalBody id={"modalBody"}>
                            <p>{modalMessage}</p>
                        </ModalBody>
                        {footer}
                    </Modal>
                }
            </span>
        );
    }
}